import { render, staticRenderFns } from "./DashboardReceive.vue?vue&type=template&id=e5d41fd8&scoped=true&"
import script from "./DashboardReceive.vue?vue&type=script&lang=js&"
export * from "./DashboardReceive.vue?vue&type=script&lang=js&"
import style0 from "../InputPPM/DashboardPPCM.scss?vue&type=style&index=0&id=e5d41fd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d41fd8",
  null
  
)

export default component.exports